import React from "react";
import ReactDOM from "react-dom/client";
import App from "./src/App";
import { BrowserRouter, HashRouter } from "react-router";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
);
